import { useAuthContext } from './agencyAuthHook'
import { getAllPackages } from '../redux/reducers/packagesSlice'
import { useDispatch } from 'react-redux';

export default function PackagesHook() {
    const dispatch = useDispatch()
    const apiUrl = process.env.REACT_APP_API_URL;
    const { agency } = useAuthContext()
    const getPackages=async()=>{
       try {
        const response=await fetch(`${apiUrl}/api/agencies/packages/get`,{
          headers:{
            'Authorization': `Bearer ${agency.token}`
            
          }
        })
        
        const json=await response.json()
        if(response.ok){
          
          dispatch(getAllPackages(json.data))
        }
        
       } catch (error) {
       console.log('error',error)
       }
    }
  return {getPackages}
}
